import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
// redux
import { Provider } from 'react-redux';
// routes
import { ToastContainer } from 'react-toastify';
// eslint-disable-next-line import/no-unresolved
import { Analytics } from '@vercel/analytics/react';
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import { StyledChart } from './components/chart';
import ScrollToTop from './components/scroll-to-top';
import { store } from './store/store';
import { AppProvider } from './contexts/AppContext';
import 'react-toastify/dist/ReactToastify.css';

// ----------------------------------------------------------------------

export default function App() {
  return (
    <Provider store={store}>
      <HelmetProvider>
        <BrowserRouter>
          <AppProvider>
            <ThemeProvider>
              <style>
                {`
                  .Toastify__toast-container {
                    width: auto;
                    min-width: 350px;
                  }
                  .modern-toast-container {
                    background-color: transparent !important;
                    box-shadow: none !important;
                    padding: 0 !important;
                    margin: 0 0 12px 0 !important;
                    border-radius: 0 !important;
                  }
                  .Toastify__toast-body {
                    padding: 0 !important;
                    margin: 0 !important;
                  }
                `}
              </style>
              <ToastContainer 
                position="top-right"
                autoClose={4000}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
              />
              <ScrollToTop />
              <StyledChart />
              <Router />
              <Analytics />
            </ThemeProvider>
          </AppProvider>
        </BrowserRouter>
      </HelmetProvider>
    </Provider>
  );
}
